import {Action} from "redux";
import {ICustomerBlackListActionCreator} from "../action/customer_black_list_action";

import {
    AddCustomerBlackListRequest, DeleteCustomerBlackListRequest,
    GetCustomerBlackListRequest,
} from "../request/customer_black_request";

interface ICustomerBlackListDispatcher {

    getCustomerBlackList(item: GetCustomerBlackListRequest): void;

    addCustomerBlackList(item: AddCustomerBlackListRequest): void;

    deleteCustomerBlackList(item: DeleteCustomerBlackListRequest): void;

}

class Dispatcher implements ICustomerBlackListDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerBlackListActionCreator) {

    }

    public getCustomerBlackList = (item: GetCustomerBlackListRequest): void => {
        this.dispatch(this.actionCreator.requestGetCustomerBlackListAction(item));
    };

    public addCustomerBlackList = (item: AddCustomerBlackListRequest): void => {
        this.dispatch(this.actionCreator.requestAddCustomerBlackListAction(item));
    };

    public deleteCustomerBlackList = (item: DeleteCustomerBlackListRequest): void => {
        this.dispatch(this.actionCreator.requestDeleteCustomerBlackListAction(item));
    };

}

const createCustomerBlackListDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerBlackListActionCreator): ICustomerBlackListDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerBlackListDispatcher, createCustomerBlackListDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_black_list_dispatcher.ts